var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110.2 141.4",
    style: {
      enableBackground: "new 0 0 110.2 141.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#87CDD3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.9,41.2c-6,0.2-12,0-18,0c-2.7,0-5.4-0.1-8.2,0c-2.2-0.1-4.1,1.7-4.2,3.9c0,0.5,0.1,1,0.2,1.5 c0.7,1.8,2.1,2.7,4.6,2.8h26.1c0.6,0,1.1,0.1,1.6,0.1v83.6H48.8l0,0H8.3V72.4l0,0V49.3h1.8c8.5,0,17,0,25.5,0c0.6,0,1.2,0,1.8-0.1 c1.9-0.3,3.3-2,3.3-3.9c0-2.4-1.8-4.1-4.5-4.1c-9.1,0-18.2,0-27.4,0C3.4,41.2,0,44.5,0,50v22.4l0,0v60.2c0,0.7,0,1.3,0.1,2 c0.8,4.2,4.1,6.8,8.6,6.8h64.7l0,0h27.9c4.5,0,7.3-2,8.6-6.3c0.1-0.2,0.1-0.4,0.2-0.5V47.8C108.6,42.7,105,41,99.9,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.7,27.4c5.6-4.8,11.2-9.6,16.9-14.4c0.4-0.4,0.9-0.7,1.6-1.2v1.5c0,13.6,0,27.2,0,40.8l0,0v13.6 c0,2.2,0,4.3,0,6.4c0.1,2,1.7,3.6,3.7,3.7c2,0.1,3.8-1.2,4.2-3.1c0.1-0.7,0.2-1.4,0.1-2.1v-9.3l0,0V11.8c0.8,0.6,1.3,1,1.8,1.4 l10.9,9.3c2,1.7,4,3.5,6.1,5.2c1.7,1.5,4.2,1.3,5.7-0.4s1.3-4.2-0.4-5.7c-0.4-0.4-0.8-0.8-1.3-1.1L60.8,2.3 c-3.6-3.1-7.8-3.1-11.4,0l-9.2,7.9l-12.8,11c-1.4,1-2,2.7-1.6,4.3C26.5,28.7,30,29.6,32.7,27.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIos);
export default __webpack_public_path__ + "static/media/share-ios.1e28167479b76441ac08de62e512c713.svg";
export { ForwardRef as ReactComponent };